import { present } from 'shared/presenters/presenter'
import { Booking_Invites } from './graphqlTypes'

export class BookingInvitePresenter extends present<Booking_Invites>() {}
